/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled from 'styled-components';

export const Box = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
  margin-top: 48px;
  margin-bottom: 32px;
`;

export const ButtonsBox = styled.div`
  display: flex;
  margin-right: auto;
`;

export const Heading = styled.h2`
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 32px;
  color: ${Palette.PrimaryGray._900};
`;
